<div class="header">
	<div class="profile-container">
		<img src="/assets/images/logo.jpg" class="profile-image" [alt]="user?.name" />
		<div class="user-greetings">
			<p class="profile-name">Welcome, {{ user?.name }}!</p>
			<span>{{ greetings }}</span>
		</div>
	</div>
</div>
